<template>
  <div class="py-4 container-fluid">
    <div class="card mb-4">
      <form @submit.prevent="submitForm(false)" class="card-body">
        <div class="row">
          <div>
            <label for="description" class="form-label required">متن توضیحات</label>
            <textarea class="form-control" rows="3" id="description" name="description" v-model.trim="description" />
          </div>
          <div>
            <label for="fileSelector" class="form-label">پیوست</label>
            <file-selector ref="fileSelector" maxFileCount="3" maxFileSize="50 * 1024 * 1024"
              @filesUpdate="updateFiles" />
          </div>
          <div class="col-md-6"></div>
          <div v-if="getPermission(1140).insert" class="col-md-6">
            <label for="section" class="form-label">وضعیت جدید، اگر مایل به تغییر آن هستید</label>
            <vue-select v-model="status" :options="statuses" dir="rtl" label="title">
              <template #no-options="{ search, searching, loading }">
                موردی یافت نشد!
              </template>
            </vue-select>
          </div>
        </div>
        <hr class="horizontal dark" />
        <template v-if="v.$error">
          <show-errors :model-value="v.$errors"></show-errors>
          <hr class="horizontal dark" />
        </template>
        <div>
          <button class="btn bg-gradient-success mb-0" type="submit" :disabled="lockButtons">ثبت</button>
          <button v-if="getPermission(1140).insert" class="btn bg-gradient-warning-2 text-white me-3 float-start mb-0"
            type="button" @click="changeStatus" :disabled="lockButtons">
            تغییر وضعیت بدون ثبت توضیح
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import TicketService from '@/services/Ticket/Ticket-service.js';
import BaseService from '../../services/Base-service';
import { maxLength, helpers, required } from '@vuelidate/validators';
import FileSelector from '../components/File/FileSelector.vue';
import { mapGetters } from "vuex";

export default {
  components: { FileSelector },
  props: ['ticketId', 'companyId'],
  emits: ['submited',],
  data() {
    return {
      v: this.$useVuelidate(),
      description: '',
      forCompany: false,
      status: null,
      statuses: [],
      files: [],
      lockButtons: false,
    }
  },
  computed: {
    ...mapGetters(['getPermission']),
  },
  watch: {
    companyId() {
      if (this.getPermission(1140).insert) {
        this.getStatusesByCompany();
      }
    },
  },
  methods: {
    submitForm(closeTicket) {
      this.v.$validate();
      if (this.v.$error) {
        return;
      }

      this.lockButtons = true;

      let postFileAddrees = '';
      if (this.getPermission(1140).insert) { postFileAddrees = '/Ticket/AddTicketDetailWithStatus'; }
      else if (closeTicket) { postFileAddrees = '/Ticket/CloseTicketByOwner'; }
      else { postFileAddrees = '/Ticket/AddTicketDetail' }

      let ticketDetail = new FormData();
      ticketDetail.append('Message', this.description);
      ticketDetail.append('TicketId', this.ticketId);
      if (this.status) {
        ticketDetail.append('TicketStatusId', this.status.id);
      }
      for (var i = 0; i < this.files.length; i++) {
        ticketDetail.append("Files", this.files[i]);
      }

      BaseService.postFile(postFileAddrees, ticketDetail).then(response => {
        let result = response.data;

        if (result.success) {
          this.$toast.success(result.message);
          this.description = '';
          this.status = null;
          this.$refs.fileSelector.files = [];
        } else {
          this.$toast.error(result.message);
        }
        this.lockButtons = false;
      }).then(() => {
        this.$emit('submited');
      }).catch(e => {
        console.log(e);
      });

      this.v.$reset();
    },
    getStatusesByCompany() {
      TicketService.getStatusesByCompany(this.companyId).then(response => {
        let result = response.data;
        if (result.success) {
          this.statuses = result.data;
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    changeStatus() {
      if (this.status) {
        this.lockButtons = true;

        let statusHistory = {
          ticketId: this.ticketId,
          ticketStatusId: this.status.id,
        };

        TicketService.changeTicketStatus(statusHistory).then(response => {
          let result = response.data;

          if (!result.success) {
            this.$toast.error(result.message);
          } else {
            this.$toast.success(result.message);
            this.status = null;
          }
          this.lockButtons = false;
        }).then(() => {
          this.$emit('submited');
        }).catch(e => {
          console.log(e);
        });
      }
      else {
        this.$toast.error("لطفا وضعیت مورد نظر را مشخص کنید");
      }
    },
    updateFiles(files) {
      this.files = files;
    },
  },
  created() {
    if (!this.$store.state.currentUserInfo.customerId) {
      this.forCompany = true;
    }
  },
  validations() {
    let valObj = {
      description: {
        required: helpers.withMessage('لطفا "متن توضیحات" را وارد کنید', required),
        maxLength: helpers.withMessage('حد‌اکثر طول مجاز برای "متن توضیحات"، 65000 کاراکتر است', maxLength(65000)),
      },
    };

    return valObj;
  }
}
</script>